import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { YellowButton } from '../common/style/button'
import { NewTabLink } from '../common/style/components/links'
import { mobile } from '../common/style/media-queries'
import { cookieAcknowledgmentId } from '../selectors'

export const CookiesDisclosure = () => {
  const [t] = useTranslation('cookies_discosure')
  const [hasAknowledged, setHasAknowledged] = useLocalStorage(
    'cookies_aknowledgement',
    '0'
  )

  if (hasAknowledged === '1') {
    return null
  }

  return (
    <Wrapper>
      <div>
        <Title>{t('title')}</Title>
        <Description>
          {t('description')}{' '}
          <Link to={t('privacy_link')} eventLabel="cookie_privacy_link">
            {t('privacy')}
          </Link>
          {t('privacy_after')}
        </Description>
      </div>
      <YellowButton
        onClick={() => setHasAknowledged('1')}
        id={cookieAcknowledgmentId}
      >
        {t('i_agree')}
      </YellowButton>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #f3f7f9;
  padding: 30px 60px;
  z-index: 10;

  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;

  @media ${mobile} {
    flex-direction: column;
    padding: 20px 18px;
  }
`

const Title = styled.h3`
  font-size: 24px;
  margin-top: 0;
  margin-bottom: 10px;
  font-weight: bold;
  color: #33455b;
`

const Link = styled(NewTabLink)`
  text-decoration: underline;
`

const Description = styled.p`
  font-size: 14px;
  color: #33455b;
  margin-top: 0;
  margin-bottom: 0;
  max-width: 860px;
  margin-right: 50px;

  @media ${mobile} {
    margin-bottom: 20px;
    text-align: center;
    margin-right: 0px;
  }
`

export const useLocalStorage = (key: string, initialValue: string) => {
  const [value, setValue] = useState(localStorage.getItem(key) || initialValue)

  const set = (newValue: string) => {
    localStorage.setItem(key, newValue)
    setValue(newValue)
  }

  return [value, set] as [string, (newValue: string) => void]
}
